import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0px 20px;
  min-height: 85px;
`;
